<script lang="ts">
import { onDestroy, onMount } from 'svelte';
import route from '../Util/routes';

import type { MyFitnessStores } from './stores';
import TrainingStatus from './TrainingStatus.svelte';
  import HelpTooltip from '@/Common/HelpTooltip.svelte';

export let myFitness: MyFitnessStores;
// Destructure stores from object becuase can't access stores as $myFitness.trainingAdvice, etc.
// https://github.com/sveltejs/svelte/issues/4079
let { trainingAdvice } = myFitness

export let last_breakthrough;
export let first_name, last_name, profile_photo, premium, subscription, plan_icon;
export let athlete, workout_description;

export let periods;

let compact = false;
let innerWidth = 0;

$: compact = innerWidth <= 1200;

//@ts-ignore
let Xert = window.Xert;
//@ts-ignore
let jq = window.$;
//@ts-ignore
let CountUp = window.CountUp; // TODO: Use svelte for fancy count-up animation?

onDestroy(trainingAdvice.subscribe((trainingAdvice)=>{
    // this needs to be called in onTimeout since
    // it uses jquery to poke at elements.
    // TODO: remove setTimeout after refactoring to svelte.
    // (i.e. trainingAdvice is ready before html elements are ready)
    setTimeout(()=>{

        updateSignatureNumbers(trainingAdvice);
    }, 0);
}));

function updateSignatureNumbers(advice) {
    let sig = advice.signature;
    let tpCountUp = new CountUp('threshold_power', 0, sig.ftp, 0, 2, {useEasing: true});
    tpCountUp.start();

    let hieCountup = new CountUp('high_intensity_energy', 0, (sig.atc / 1000).toFixed(1), 1, 2, {useEasing: true});
    let ppCountUp = new CountUp('peak_power', 0, sig.pp, 0, 2, {useEasing: true});
    let ltpCountUp = new CountUp('lower_threshold_power', 0, sig.ltp, 0, 2, {useEasing: true});

    let unitType = advice.target_athlete_details.per_weight ? ' W/kg' : ' W';
    setInnerText('current_fitness_units', unitType);
    let fmCountUp = new CountUp('current_fitness_measure', 0, Xert.MyFitness.formatNumber(advice.current_FM, advice.target_athlete_details.per_weight), advice.target_athlete_details.per_weight ? 1 : 0, 2, {useEasing: true});

    hieCountup.start();
    ppCountUp.start();
    ltpCountUp.start();
    fmCountUp.start();
}

// TODO: Refactor to not use this function.
function setInnerText(id, text) {
    document.getElementById(id).textContent = text;
}

onMount(()=>{

    // TODO: Use proper svelte code for setting text.
    setInnerText('threshold_units', 'W');
    setInnerText('high_intensity_energy_units', 'kJ');
    setInnerText('lower_threshold_power_units', 'W');
    setInnerText('current_fitness_units', 'W');
    setInnerText('peak_power_units', 'W');

    let truncate = jq('.truncate');
    if (truncate[0]) {
        let date_for_humans = jq('.date_for_humans');
        if (truncate.width() < truncate[0].scrollWidth){
            date_for_humans.css('text-align', 'center')
            date_for_humans.css('display', 'block');
        }
    }
});  

</script>

<svelte:window bind:innerWidth/>

<div id="header" class:compact={compact} class="profile-container animated">
    <div id="profile-wrapper">
        <img class="profile-img object-cover" src={profile_photo} alt="User portrait"/>
        <div class="profile-info">
            <div class="username">
                {#if premium}
                    <img class="premium" data-toggle="tooltip"
                        title={subscription}
                        src={plan_icon}
                        alt="Premium User Badge" />
                {/if}
                {first_name} {last_name}
            </div>
            <div class="substats-container whitespace-nowrap flex-wrap">
                <div class="athlete_type">
                    {athlete}
                    {#if compact}
                        |&nbsp;
                    {/if}
                </div>
                <div><TrainingStatus trainingAdvice={$trainingAdvice}/></div>
            </div>
            {#if last_breakthrough}
                <div id="breakthrough-wrapper" class="max-w-full">
                    <span class="flex flex-wrap whitespace-nowrap justify-end">
                        Last Breakthrough:
                            <a class="truncate ml-2 flex-1 min-w-[80px]" href="{ route('ActivityController@getActivity', [last_breakthrough['path']])}">
                            { last_breakthrough['name'] }
                        </a>
                        <span class="date_for_humans subtext">
                            {last_breakthrough['start_date']}
                            {#if last_breakthrough['stale']}
              <HelpTooltip
                message="Your Fitness Signature may be out of date. It&rsquo;s been a while since your last breakthrough, so your current signature may be underestimating your fitness. Try a maximal effort or high-intensity workout to update it. <a href='https://baronbiosys.com/glossary/breakthroughs/' target='_help'>Learn more</a>"
                icon="fa fa-warning"
                label="Fitness Signature may be out of date"
                iconClass="text-amber-500"
              />
              {/if}
                        </span>
                    </span>
                </div>
            {/if}
        </div>
    </div>
    <div class="xert_stats">
        <div class="grid_container">
            <div class="stats_box" data-toggle="tooltip" id="threshold_box">
                <span class="threshold_content">
                    <span id="threshold_power">0</span>
                    <span class="stats_units" id="threshold_units"></span>
                </span>
                <span class="stats_title"> Threshold Power</span>
                <!-- <span class="stats_title visible-xs">TP</span> -->
            </div>
            <div class="stats_box" data-toggle="tooltip">
                <span class="stats_content">
                    <span id="high_intensity_energy">0</span>
                    <span class="stats_units" id="high_intensity_energy_units"></span>
                </span>
                <span class="stats_title"> High Intensity Energy</span>
                <!-- <span class="stats_title visible-xs"> HIE</span> -->
            </div>
            <div class="stats_box" data-toggle="tooltip">
                <span class="stats_content">
                    <span id="peak_power">0</span>
                    <span class="stats_units" id="peak_power_units"></span>
                </span>
                <span class="stats_title"> Peak Power</span>
                <!-- <span class="stats_title visible-xs">PP</span> -->
            </div>
            <div class="stats_box compact-hidden" data-toggle="tooltip">
                <span class="stats_content">
                    <span id="current_fitness_measure">0</span>
                    <span class="stats_units" id="current_fitness_units"></span>
                </span>
                <span class="stats_title"> {workout_description} </span>
            </div>
            <div class="stats_box" data-toggle="tooltip">
                <span class="stats_content">
                    <span id="lower_threshold_power">0</span>
                    <span class="stats_units" id="lower_threshold_power_units"></span>
                </span>
                <span class="stats_title hidden-xs"> Lower Threshold Power</span>
                <span class="stats_title visible-xs"> LTP</span>
            </div>
        </div>
    </div>
</div>

<style lang="scss">
    .animated * {
        transition-property: width, height, font-size, font-weight, color;
        transition-duration: 0.25s;
    }
    .compact {
        & .profile-img {
            width: 61.5px;
            height: auto;
        }
        & .username {
            font-size: 20px;
            font-weight: 700;
            color: #3D3D3D;
        }
        & .athlete_type {
            font-size: 14px;
            font-weight: 400;
            color: #3D3D3D;
        }
        & .stats_box {
            height: auto;
        }
        & .compact-hidden {
            display: none;
        }
        & .compact-only {
            visibility: visible;
            opacity: 1;
            height: auto;
        }
        & .grid_container {
            display: flex;
            flex-direction: row;
        }
        & .xert_stats {
            justify-content: right;
        }
        & .substats-container {
            flex-direction: row;
            align-items: end;
        }
    }
    
    .compact-only {
       visibility: hidden;
       opacity: 0;
       height: 0;
    }
    #profile-wrapper {
        display: flex;
    }
    :not(.compact) > #profile-wrapper {
        max-width: 50%;
    }
    .substats-container {
        display: flex;
        flex-direction: column;
    }
    .profile-img {
        margin-right: 16px;
    }

    .truncate {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        //width: 100%;
        display: inline-block;
    }

</style>
